import { HttpClient } from "@angular/common/http";
import { UrlServidor } from "../util/url-servidor";
import { Observable } from "rxjs";
import { EntradaEstoque } from "../api/dto/entrada-estoque";
import { Injectable } from "@angular/core";

@Injectable({providedIn: 'root'})
export class EntradaEstoqueService {
    constructor(private http: HttpClient) { }
    private url: string = UrlServidor.URL_BASE + 'entradas-estoque';

    listarPorEmpresaId(id?: number): Observable<EntradaEstoque[]> {
        return this.http.get<EntradaEstoque[]>(`${this.url}/empresa/${id}`);
    }

    buscarPorId(id?: number): Observable<EntradaEstoque> {
        return this.http.get<EntradaEstoque>(`${this.url}/${id}`);
    }

    salvar(entradaEstoque?: EntradaEstoque): Observable<EntradaEstoque> {
        return this.http.post<EntradaEstoque>(this.url, entradaEstoque);
    }

    atualizar(entradaEstoque?: EntradaEstoque): Observable<EntradaEstoque> {
        return this.http.put<EntradaEstoque>(this.url, entradaEstoque);
    }

    excluirMovimentoEntrada(idEntrada?: number, idProduto?: number): Observable<void> {
        return this.http.delete<void>(`${this.url}/entrada/${idEntrada}/produto/${idProduto}`);
    }

    excluirEntrada(idEntrada?: number): Observable<void> {
        return this.http.delete<void>(`${this.url}/${idEntrada}`);
    }

    buscarPercentualFreteUltimaEntrada(empresaId?: number, itemId?: number): Observable<number> {
        return this.http.get<number>(`${this.url}/empresa/${empresaId}/item/${itemId}/percentual-frete`);
    }

}